import { AppSettings } from '../appSettings'

export class HubspotCerberusClient  {
  static hostname: string;
  static project_key: string;
  static feature_flag_id: string;
  static autentication_key: string;
  static environment_key: string;
  static rule_id: string;
  static clause_id: string;
  
  static async setParamValues() {
    const ld_integration = await AppSettings.get('LD_INTEGRATION');
    
    this.hostname = ld_integration['HOSTNAME'];
    this.project_key = ld_integration['PROJECTKEY'];
    this.feature_flag_id = ld_integration['FEATURE_FLAG_ID'];
    this.autentication_key = ld_integration['AUTHENTICATIONKEY'];
    this.environment_key = ld_integration['ENVIRONMENTKEY'];
    this.rule_id = ld_integration['RULEID'];
    this.clause_id = ld_integration['CLAUSEID'];
  }

  static async enableEmailContractView(owner_Identity) {
    
    const callHubspotCerberusApi = async (endpoint) => {
      const headers = new Headers();
      const body = JSON.stringify({
          environmentKey: this.environment_key,
          instructions: [
            {
              ruleId: this.rule_id,
              clauseId: this.clause_id,
              values: [
                owner_Identity
              ]
            }
          ]
        });
     
      headers.append('ApiKey', this.autentication_key);
      headers.append('Content-Type','application/json');
      
      const options = {
        method: 'PATCH',
        headers: headers,
        body: body
      };  
    
      const response = await fetch(endpoint, options);
      if(!response.ok)
      {
        throw new Error(`LaunchDarkly Integration response status code: ${response.status}`);
      }
      const data = await response;   
      return data;
    }

    const endpoint = `${this.hostname}/api/LaunchDarkly/FeatureFlag/Update/AddValuesToClause?projKey=${this.project_key}&featureFlagId=${this.feature_flag_id}`;
    await callHubspotCerberusApi(endpoint);

  }
}